import http from "../http-common";

class CliniqueService{
    getAll(idville) {
        return http.get("https://dev-ci.alaxione.fr/ajax/widget_liste_etablissement.php?idville=" + idville);
    }
}

export default new CliniqueService();